import React from 'react';
import { Box } from '@applyboard/ui-components';
import Layout from "./Layout";
import CefCard from "../CefCard";
import { useIsMobile } from "../../Common/useIsMobile";
import Progress from "../../../Wizards/Progress";
var CefMobilePageWrapper = function CefMobilePageWrapper(props) {
  var children = props.children,
    onExit = props.onExit,
    onSave = props.onSave,
    footerButton = props.footerButton;
  var isMobile = useIsMobile();
  return isMobile ? /*#__PURE__*/React.createElement(Layout, {
    onExit: onExit,
    onSave: onSave
  }, /*#__PURE__*/React.createElement(Progress, null), children, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    width: "100%",
    left: 0,
    bottom: 0
  }, footerButton)) : /*#__PURE__*/React.createElement(CefCard, null, /*#__PURE__*/React.createElement(Layout, {
    onExit: onExit,
    onSave: onSave
  }, /*#__PURE__*/React.createElement(Progress, null), children), footerButton);
};
export default CefMobilePageWrapper;